import * as React from 'react';
import {view, deprecatedCss} from '@sail/engine';
import {Checkbox} from '@sail/ui';

export const Disabled = () => {
  const [checked, setChecked] = React.useState(false);
  return (
    <view.div
      uses={[
        deprecatedCss`
          layout: column;
        `,
      ]}
    >
      <Checkbox
        label="This uncontrolled Checkbox is disabled."
        defaultChecked
        disabled
      />
      <Checkbox
        onChange={() => {
          setChecked(!checked);
        }}
        checked={checked}
        disabled
        label="This controlled Checkbox is disabled."
      />
      <Checkbox
        disabled
        invalid
        defaultChecked
        label="This uncontrolled, invalid Checkbox is disabled."
      />
    </view.div>
  );
};
